import { render, staticRenderFns } from "./widgets-group.vue?vue&type=template&id=5684d3af&scoped=true&"
import script from "./widgets-group.vue?vue&type=script&lang=js&"
export * from "./widgets-group.vue?vue&type=script&lang=js&"
import style0 from "./widgets-group.vue?vue&type=style&index=0&id=5684d3af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684d3af",
  null
  
)

export default component.exports